import { render, staticRenderFns } from "./select-platform-product.vue?vue&type=template&id=1e9b70d6&scoped=true"
import script from "./select-platform-product.ts?vue&type=script&lang=ts&external"
export * from "./select-platform-product.ts?vue&type=script&lang=ts&external"
import style0 from "./select-platform-product.scoped.scss?vue&type=style&index=0&id=1e9b70d6&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e9b70d6",
  null
  
)

export default component.exports